<template>
  <v-row justify="center">
    <v-dialog v-model="showDialog" persistent max-width="400">
      <v-card>
        <div class="text-body-1 pa-3">
          <v-icon class="mr-2" color="warning" large> {{ icon }}</v-icon>
          {{ text }}
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn dense outlined class="mr-2 bold" @click="closeDialog">
            {{ $t("common.words.cancel") }}
          </v-btn>
          <v-btn dense color="primary" class="bold" @click="confirmAction">
            {{ buttonText }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "ConfirmationDialogVT",
  data() {
    return {
      showDialog: true,
    };
  },
  props: {
    icon: { String, default: "mdi-alert" },
    id: {
      type: [String, Number],
      required: true,
    },
    buttonText: String,
    text: String,
  },
  methods: {
    confirmAction() {
      this.$emit("confirm_action", {
        id: this.id,
      });
      this.$emit("closeDialog");
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
  },
};
</script>
